/**
 * NumberFormatters — desktop port of BigxBookApp/src/printing/engine/NumberFormatters.ts.
 */

export const formatInr = (value: number): string => {
  const abs = Math.abs(value);
  const formatted = abs.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${value < 0 ? '-' : ''}₹${formatted}`;
};

export const formatQty = (qty: number): string => {
  return qty.toFixed(1);
};
